<template>
  <div class="container monitoring-list-container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{ $t('lbl.admin.log_header') }}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Condition search -->
    <v-row
      class="mb-0 custom-form-control custom-form-control-type-2 custom-form-control-type-4 custom-figma-1"
    >
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0"
            cols="12"
            xl="7"
            lg="7"
            md="12"
          >
            <v-row class="pt-0 pb-0 mt-0 mb-2">
              <v-col
                v-if="Number($cookies.get('use-grade')) === 9"
                cols="12"
                lg="3"
                md="6"
                class="pt-0 pb-0 mb-0"
              >
                <v-autocomplete
                  v-model="groupId"
                  @change="searchData"
                  :items="logTypeList"
                  :menu-props="{ offsetY: true }"
                  :label="$t('lbl.common.conditionSearch.selectLog')"
                  width="60px"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" md="6" class="pt-0 pb-0 pr-0">
                <v-autocomplete
                  v-model="userId"
                  @change="searchData"
                  :items="compList"
                  :menu-props="{ offsetY: true }"
                  :label="$t('lbl.common.conditionSearch.selectCompany')"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="processSetupId"
                  :label="$t('lbl.common.conditionSearch.findbySetupID')"
                  @keyup.enter="searchData"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="processId"
                  @keyup.enter="searchData"
                  :label="$t('lbl.common.conditionSearch.findbyProcessID')"
                  dense
                  filled
                  hide-details
                  class="custom-selectbox"
                ></v-text-field>
              </v-col>
            </v-row>
            <!--2nd row condition search-->
            <v-expand-transition>
              <div>
                <v-row>
                  <v-col
                    class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
                    cols="12"
                    lg="12"
                    md="24"
                  >
                    <v-row class="pt-0 pb-0 mb-4 align-center">
                      <v-col cols="12" xl="2" lg="2" md="6" class="pt-0 pb-0">
                        <v-row class="pt-0 pb-0 mt-0 mb-0">
                          <v-col cols="12" lg="12" md="12" class="pt-0 pb-0">
                            <v-autocomplete
                              v-model="logLevel"
                              class="custom-selectbox"
                              :label="$t('lbl.common.conditionSearch.selectLogLevel')"
                              :items="logLvlList"
                              @change="searchData"
                              dense
                              filled
                              hide-details
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" xl="4" lg="3" md="6" class="pt-0 pb-0">
                        <v-tooltip top :max-width="tooltipWidth">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="on"
                              v-model="message"
                              :disabled="timeRange > 1 && !processSetupId && !processId"
                              :label="$t('lbl.common.conditionSearch.findbyMessage')"
                              @keyup.enter="searchData"
                              class="custom-selectbox"
                              dense
                              filled
                              hide-details
                            ></v-text-field>
                          </template>
                          <span>{{ $t('msg.systemLog.messageSearchTooltipMsg') }}</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" xl="3" lg="3" md="6" class="pt-0 pb-0"></v-col>
                      <v-col cols="12" xl="3" lg="4" md="6" class="pb-0 pt-0">
                        <v-tooltip top :max-width="tooltipWidth">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="pl-0 pt-0 pb-0 d-inline-flex code-table-section"
                            >
                              <v-checkbox
                                v-model="dateCond"
                                :disabled="!(processId || processSetupId)"
                                class="mt-0 pt-0"
                                hide-details
                                @change="searchData"
                                dense
                                solo
                              ></v-checkbox>
                            </div>
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="pl-0 pt-0 pb-0 d-inline-flex code-table-section"
                            >
                              <span
                                class="all-code-label"
                                style="position: relative;top: -2px;left: -12px;"
                                >{{ $t('msg.common.applyDateCond') }}</span
                              >
                            </div>
                          </template>
                          <span>{{ $t('msg.systemLog.applyDateConditionTooltipMsg') }}</span>
                        </v-tooltip>
                      </v-col>
                      <!-- <v-col cols="12" xl="1" lg="2" md="4" class="pt-0 pb-0 pr-0"></v-col> -->
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>
          </v-col>

          <!-- Time Condition -->

          <v-col
            xl="1"
            lg="1"
            md="12"
            class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 custom-figma-1"
          >
          </v-col>
          <v-col
            class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 custom-figma-1 text-right"
            cols="12"
            xl="4"
            lg="4"
            md="12"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateData"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDateData"
                  :disabled="!dateCond"
                  :max="getMaxDate"
                  @input="
                    fromDate = false;
                    changeDate('from');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.fromdate_menu.save(fromDateData)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromtime_menu"
                v-model="fromTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromTimeData"
                    :disabled="!dateCond"
                    :class="['time-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-clock-outline"
                    dense
                    solo
                    @keypress="formatTime('from', $event)"
                    @change="validateTimeInput('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-time-picker
                  :disabled="!dateCond"
                  v-model="fromTimeData"
                  class="time-picker"
                  scrollable
                  format="ampm"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromtime_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.fromtime_menu.save(fromTimeData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-time-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="toDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateData"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  class="date-period-picker"
                  :allowed-dates="allowedDates"
                  v-model="toDateData"
                  :disabled="!dateCond"
                  @input="
                    toDate = false;
                    changeDate('to');
                  "
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.todate_menu.save(toDateData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>

            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="totime_menu"
                v-model="toTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toTimeData"
                    :disabled="!dateCond"
                    :class="['time-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-clock-outline"
                    dense
                    solo
                    @keypress="formatTime('to', $event)"
                    @change="validateTimeInput('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-time-picker
                  :disabled="!dateCond"
                  v-model="toTimeData"
                  class="time-picker"
                  scrollable
                  format="ampm"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="totime_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.totime_menu.save(toTimeData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-time-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn class="btn btn-top btn-search btn-width-1" color="primary" @click="searchData">
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Button Action -->
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="8" md="7"> </v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5"> </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="40"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Grid table List -->
    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :footer-props="{
            showFirstLastPage: true,
          }"
          :search="searchByTxt"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          hide-default-footer
          :class="[
            'list-table srm-list-table custom-border-table',
            totalCnt > 0 ? '' : 'custom-border-table-not-data',
          ]"
        >
          <!-- <v-col> </v-col> -->
          <template v-slot:item.groupId="{ item }">
            <a class="col-id">{{ item.groupId == 'system' ? 'system' : 'process' }}</a>
          </template>
          <template v-slot:item.userId="{ item }">
            <a class="col-id">{{ item.userId }}</a>
          </template>
          <template v-slot:item.processSetupId="{ item }">
            <a
              v-if="item.processSetupId != 'system'"
              class="link-file-text cursor-pointer layout-col"
              @click="openViewWorkflowWindow(item)"
              >{{ item.processSetupId }}</a
            >
            <font v-if="item.processSetupId == 'system'">{{ item.processSetupId }}</font>
          </template>
          <template v-slot:item.processId="{ item }">
            <a
              class="link-file-text cursor-pointer layout-col"
              @click="openProcessDetailWindow(item)"
              >{{ item.processId }}</a
            >
          </template>
          <template v-slot:item.request_timestamp="{ item }">
            <font class="col-id">{{ item.processSetupId }}</font>
          </template>
          <template v-slot:item.request_timestamp="{ item }">
            <font>{{ applyGmtTimeZone(item.request_timestamp) }}</font>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ totalCnt - itemsPerPage * page > 0 ? itemsPerPage * page : totalCnt }}
                    of {{ totalCnt }}
                  </v-label>
                </div>
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="Validation"
      size="max"
      :detail="$t('msg.systemLog.messageSearchValidation')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="Validation"
      :info="checkDialogTitle"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import $ from 'jquery';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';

// 2021.5.19 203728 Issue 53
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
// 2021.12.1 SPKA-297 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { setProcessWindowList, deleteProcessWindow } from '@/vue-caas/utils/process';
import { openWindow } from '@/vue-dlb/utils/window-opener';

const moment = require('moment');

export default {
  components: {
    SystemProgress,
    dialogWindow,
  },
  props: {
    items: {
      default: Array,
    },
  },

  data() {
    return {
      dateCond: true,
      checkSearchKeyBy: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      searchBy: '',
      searchByTxt: '',
      groupId: undefined,
      userId: undefined,
      processSetupId: undefined,
      processId: undefined,
      logLevel: undefined,
      message: undefined,
      listData: [],
      tempDataInfo: [],
      arrLayoutDialog: [],
      dialogFileView: false,
      dialogErrView: false,
      dialogs: [],
      dialogId: 1,
      dialog: false,
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      checkDialogTitle: 'Alert',
      isCreated: false,
      tableHeight: '',
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      fromDateData: getAppliedTimeZone(),
      fromDate: false,
      fromTimeData: '00:00',
      fromTime: false,
      toDateData: getAppliedTimeZone(),
      toDate: false,
      toTimeData: '23:59:59',
      toTime: false,
      timeRange: 0,
      logTypeList: ['All', 'system', 'process'],
      compList: [],
      processData: {},
      logLvlList: ['All', 'notice', 'fatal', 'error', 'warn', 'info', 'debug', 'trace'],
      compOrgList: [],
      userViewArr: [],
      isLoading: false,
      totalCnt: 0,
      pageEnter: 1,
      gmtTmzn: '',
      tooltipWidth: 400,
    };
  },

  computed: {
    ...mapState('common', {
      repomenuMode: 'repomenuMode',
      sysloadingTitle: 'sysloadingTitle',
    }),
    getMaxDate() {
      return getAppliedTimeZone();
    },
    getMinDate() {
      return this.fromDateData;
    },
    headers() {
      let headers = [
        {
          text: this.$t('tbl.common.columnNo'),
          value: 'INDEX',
          align: 'center',
          width: 30,
        },
        { text: 'Log Type', value: 'groupId', align: 'center', width: 150 },
        { text: 'Company ID', value: 'userId', align: 'center', width: 150 },
        {
          text: 'Setup ID',
          value: 'processSetupId',
          align: 'center',
          width: 150,
        },
        { text: 'Process ID', value: 'processId', width: 180 },

        { text: 'Emitter ID', value: 'emitterId', width: 100 },
        { text: 'Process Code', value: 'processCode', width: 100 },
        {
          text: 'Error Code',
          value: 'errorCode',
          align: 'center',
          width: 150,
        },
        {
          text: 'Log Level',
          value: 'logLevel',
          align: 'center',
          width: 100,
        },
        { text: 'Message', value: 'message', width: 150 },
        {
          text: 'Date & Time',
          value: 'request_timestamp',
          align: 'center',
          width: 160,
        },
      ];

      if (this.groupId == 'system') {
        headers = headers.filter(
          (item) => !(item.value == 'processSetupId' || item.value == 'processId')
        );
      }
      return headers;
    },
  },

  watch: {
    listData() {
      return this.listData;
    },
    page() {
      this.pageEnter = this.page;
    },
  },

  async created() {
    this.groupId = 'All';
    this.userId = '';
    const params = [];
    this.searchData();
    this.$store.dispatch('getCompanyMngList', params).then(() => {
      this.compOrgList = this.$store.getters.apicompanies;
      this.compList.push({
        text: this.$t('lbl.common.conditionSearch.all'),
        value: '',
      });
      for (let i = 0; i < this.compOrgList.length; i += 1) {
        const comp = this.compOrgList[i];
        this.compList.push({
          text: `${comp.compNm}`,
          value: `${comp.compId}`,
        });
      }
    });
    this.isCreated = true;
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
    });
  },
  mounted() {},

  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    validateTimeInput(side) {
      let timeString = side === 'from' ? this.fromTimeData : this.toTimeData;
      var isValid = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(timeString);
      if (!isValid) {
        this.$refs.validateDate.dialog = true;
        side === 'from' ? (this.fromTimeData = '00:00') : (this.toTimeData = '23:59');
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = side === 'from' ? this.fromDateData : this.toDateData;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from' ? (this.fromDateData = dateString) : (this.toDateData = dateString);
      } else {
        return true;
      }
    },
    formatTime(side, evt) {
      let timeString = side === 'from' ? this.fromTimeData : this.toTimeData;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45 &&
        charCode !== 58
      ) {
        evt.preventDefault();
      } else if (
        charCode !== 46 &&
        charCode !== 8 &&
        charCode !== 58 &&
        timeString.length === 2 &&
        !timeString.includes(':')
      ) {
        timeString += ':';
        side === 'from' ? (this.fromTimeData = timeString) : (this.toTimeData = timeString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.fromDateData)) {
          this.$refs.validateDate.dialog = true;
          this.fromDateData = getAppliedTimeZone();
          this.toDateData = getAppliedTimeZone();
          return;
        }
        if (this.fromDateData > getAppliedTimeZone()) {
          this.fromDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.toDateData = this.fromDateData;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.toDateData)) {
          this.$refs.validateDate.dialog = true;
          this.toDateData = getAppliedTimeZone();
          this.fromDateData = getAppliedTimeZone();
          return;
        }
        if (this.toDateData > getAppliedTimeZone()) {
          this.toDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.fromDateData = this.toDateData;
        }
      }
    },

    // 2022.05.16 213979 SPKA-460 open new window popup
    openProcessDetailWindow(item) {
      const type = 'StateView';
      const params = {
        ROWID: item.processId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.processId.toString(),
        },
      };
      item.id = item.processId;
      const arrView = {
        item,
        type,
      };
      const url = `/admin/systemLog/processDetailWindow/${type}/${params.ROWID}`;
      const size = 'width=1200,height=800,left=250,top=50';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
        onMessage: (message) => {
          if (message.includes('open-state-file')) {
            this.openDataInformationFileViewWindow(
              JSON.parse(message.replace('open-state-file', ''))
            );
          }
        },
      });
    },
    openDataInformationFileViewWindow(item) {
      const type = 'FileView';
      const params = {
        ROWID: item.processId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.processId.toString(),
        },
      };
      item.id = item.processId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringDataInfoFileView/${type}/${this.params.ROWID}`;
      const size = 'width=1200,height=800,left=250,top=50';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    openViewWorkflowWindow(item) {
      const isHistory = true;
      const type = 'View';
      let processArray = item.processSetupId.split('-');
      let versionNo = 0.1;
      if (processArray.length > 1) {
        versionNo = processArray[1] / 10;
      }
      const params = {
        ROWID: processArray[0].toString(),
        type: type,
        options: {
          dataValue: processArray[0],
          id: processArray[0].toString(),
          isHistory: isHistory,
          versionNo: versionNo.toString(),
          fromTransaction: true,
        },
      };
      item.id = processArray[0];
      const arrView = {
        item,
        type,
      };
      const url = `/process/workflowDetailNew/${type}/${params.ROWID}`;
      const size = 'width=1800,height=930,left=60,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    openWarningPopUp() {
      this.isLoading = false;
      this.$refs.Validation.dialog = true;
      this.checkDialogColor = 'validation';
      this.checkDialogTitle = 'Search';
      this.checkDialogInfo = this.$t('msg.systemLog.messageSearchValidation');
    },
    getParamData() {
      let params = {
        userId: this.userId,
        processSetupId: this.processSetupId,
        processId: this.processId,
        logLevel: this.logLevel,
        message: this.message,
      };

      if (this.dateCond) {
        const fromData = this.applyGmtTimeZoneForSrchcond(
          this.fromDateData + ' ' + this.fromTimeData
        );
        const toData = this.applyGmtTimeZoneForSrchcond(this.toDateData + ' ' + this.toTimeData);
        params.filter = `request_timestamp between '${fromData}' and '${toData}'`;
        this.timeRange =
          (new Date(toData.replace(/-/g, '/')) - new Date(fromData.replace(/-/g, '/'))) /
          (24 * 60 * 60 * 1000);
      }
      if (this.groupId === 'process' || parseInt(this.$cookies.get('use-grade')) != 9) {
        params.groupId = this.$cookies.get('ownr-id');
      } else {
        params.groupId = this.groupId;
      }
      Object.keys(params).forEach((key) => {
        if (
          params[key] === null ||
          params[key] === undefined ||
          params[key] === '' ||
          params[key] === 'All'
        ) {
          delete params[key];
        }
      });
      return params;
    },
    searchData() {
      const params = this.getParamData();
      if (this.timeRange > 7) {
        this.isLoading = false;
        this.$refs.Validation.dialog = true;
        this.checkDialogColor = 'validation';
        this.checkDialogTitle = 'Search';
        this.checkDialogInfo = this.$t('msg.systemLog.dateValidate');
      } else {
        this.getLogDataList(params);
      }
    },
    getLogDataList(params) {
      this.isLoading = true;
      this.$store
        .dispatch('getLogList', params)
        .then(() => {
          const tmpListData = this.$store.getters.logList;
          this.listData = tmpListData;
          // 2022.05.16 213960 SPKA-460 search Log Type is process
          // if (this.groupId == "process") {
          //   this.listData = this.listData.filter(item => item.groupId !== "system");
          // }
          this.listData.map((e, i) => (e.INDEX = i + 1));
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
          this.page = 1;
          // 2021.5.19 203728 Issue 53
          this.isLoading = false;
        })
        .catch((ex) => {
          // 2021.5.19 203728 Issue 53
          this.isLoading = false;
        });
    },

    applyGmtTimeZone(date) {
      let newM = '';
      if (date !== undefined && date !== '') {
        newM = moment(date)
          .add(this.gmtTmzn, 'hours')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      return newM;
    },
    applyGmtTimeZoneForSrchcond(date) {
      let newM = '';
      this.gmtTmzn = this.$cookies.get('gmt-timezone');
      if (date !== undefined && date !== '') {
        if (this.gmtTmzn.indexOf(`+`) === 0)
          newM = moment(date)
            .subtract(this.gmtTmzn, 'hours')
            .format('YYYY-MM-DD HH:mm:ss');
        else if (this.gmtTmzn.indexOf(`-`) === 0)
          newM = moment(date)
            .add(this.gmtTmzn, 'hours')
            .format('YYYY-MM-DD HH:mm:ss');
      }
      return newM;
    },

    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },

    closeDialog() {
      this.$refs.Validation.dialog = false;
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
    isEnableMergeView() {
      if (this.processSetupId || this.processId) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.user-dialog {
  width: 1100px !important;
}

.fixed-height-comp {
  height: 600px;
}
.fixed-height-comp .custom-figma-1 .btn-width-1.btn-search.primary {
  width: 103px !important;
}
</style>
